class StkCikisSearchDTO {
    eklemeTarihiBaslangic?: Date;
    eklemeTarihiBitis?: Date;
    talepTarihiBaslangic?: Date;
    talepTarihiBitis?: Date;
    islemTipId?: number = null;
    depoDonemId?: number = null;
    talepNo?: string = "";
    kurumId?: number = null;
    aliciOrganizasyonId?: number = null;
    aliciServisId?: number = null;
    hastaTckn?: string = "";
    teslimEdenKullaniciId?: number = null;
    onaylayanKullaniciId?: number = null;
    teslimAlanKullaniciId?: number = null;
    ekleyenKullaniciId?: number = null;
    iptalNedenId?: number = null;

    hastaservisId?:number = null;
    firmaId?:number = null;
    diskurumId?: number = null;
}
export default StkCikisSearchDTO;